import { Button, Dropdown, Space, Typography, type MenuProps } from 'antd'
import { MoreHorizontal } from 'lucide-react'

type AccountStatus = 'pendingApproval' | 'active' | 'rejected' | 'suspended'
type MutableAccountStatus = 'active' | 'suspended'

type AccountApplicationAction = {
  id: string
  status: 'pending' | 'approved' | 'rejected'
}

export function AccountActions({
  application,
  canManageRoles,
  canManageStatus,
  isApplicationLoading,
  isStatusUpdating,
  onChangeStatus,
  onOpenApplication,
  onOpenPermissions,
  status
}: {
  application: AccountApplicationAction | null
  canManageRoles: boolean
  canManageStatus: boolean
  isApplicationLoading: boolean
  isStatusUpdating: boolean
  onChangeStatus: (status: MutableAccountStatus) => void
  onOpenApplication: (applicationId: string) => void
  onOpenPermissions: () => void
  status: AccountStatus
}) {
  const canManageAccount = status === 'active' || status === 'suspended'
  const moreItems: MenuProps['items'] = [
    ...(canManageRoles && canManageAccount
      ? [
          {
            key: 'permissions',
            label: '权限配置'
          }
        ]
      : []),
    ...(canManageRoles && canManageStatus && canManageAccount ? [{ type: 'divider' as const }] : []),
    ...(canManageStatus && canManageAccount
      ? [
          {
            disabled: status === 'active' || isStatusUpdating,
            key: 'enable',
            label: '启用账号'
          },
          {
            danger: true,
            disabled: status === 'suspended' || isStatusUpdating,
            key: 'disable',
            label: '禁用账号'
          }
        ]
      : [])
  ]

  if (moreItems.length === 0 && !application) {
    return <Typography.Text type="secondary">暂无操作</Typography.Text>
  }

  return (
    <Space size={0}>
      {application ? (
        <Button loading={isApplicationLoading} onClick={() => onOpenApplication(application.id)} type="link">
          {application.status === 'pending' ? '审核' : '详情'}
        </Button>
      ) : null}
      {moreItems.length > 0 ? (
        <Dropdown
          menu={{
            items: moreItems,
            onClick: ({ key }) => {
              if (key === 'permissions') {
                onOpenPermissions()
              }
              if (key === 'enable') {
                onChangeStatus('active')
              }
              if (key === 'disable') {
                onChangeStatus('suspended')
              }
            }
          }}
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreHorizontal aria-hidden size={16} />} loading={isStatusUpdating} size="small" type="text">
            更多
          </Button>
        </Dropdown>
      ) : null}
    </Space>
  )
}
